const s = {}, a = (n, t = document) => (Object.entries(n || {}).forEach(([e, r]) => {
  r && t.addEventListener(e, r);
}), () => {
  Object.entries(n || {}).forEach(([e, r]) => {
    r && t.removeEventListener(e, r);
  });
}), i = (n, t = []) => {
  const e = { ...n };
  return Object.keys(e).forEach((r) => {
    t.includes(r) && delete e[r];
  }), e;
}, d = (n) => {
  const e = n && n.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  return Array.from(e);
}, o = (n, t) => {
  const e = n.composedPath();
  return e.includes(t) && t !== (e == null ? void 0 : e[0]);
}, u = (n, t) => o(n, t) || n.target === t, E = (n, t = "div", e = []) => {
  const r = { ...n };
  return s[t] || (s[t] = document.createElement(t)), Object.keys(r).forEach((c) => {
    if (e.includes(c)) {
      delete r[c];
      return;
    }
    c in s[t] || c.startsWith("data-") || c.startsWith("aria-") || c.startsWith("on") || delete r[c];
  }), r;
};
export {
  a as attachEventListenerMap,
  i as denylistProps,
  d as focusableElements,
  u as interactedWithElement,
  o as interactedWithinElement,
  E as onlyDomProps
};
